import { Tag } from "antd";
import { getRoleColor } from "../constants";

/**
 * Render role tags with appropriate colors
 * @param {Array} roles - Array of role strings
 * @param {Function} translate - Translation function
 * @returns {JSX.Element} Rendered role tags
 */
export const renderRoleTags = (roles, translate = (key) => key) => (
  <span>
    {roles.map((role) => (
      <Tag color={getRoleColor(role)} key={role}>
        {translate(
          `organizations.${role === "log_manager" ? "logManager" : role}`,
        )}
      </Tag>
    ))}
  </span>
);

/**
 * Render organization tags with consistent colors
 * @param {Array} organizations - Array of organization objects
 * @param {OrganizationColorManager} colorManager - Color manager instance
 * @returns {JSX.Element} Rendered organization tags
 */
export const renderOrganizationTags = (organizations, colorManager) => (
  <>
    {organizations && organizations.length > 0 && (
      <div className="author-info">
        {organizations.map((org) => (
          <Tag key={org.org_id} color={colorManager.getColor(org.org_id)}>
            {org.name}
          </Tag>
        ))}
      </div>
    )}
  </>
);
